import { render } from "./LbrxTechnicialAssistancePopup.vue?vue&type=template&id=73961b84&scoped=true"
import script from "./LbrxTechnicialAssistancePopup.vue?vue&type=script&lang=js"
export * from "./LbrxTechnicialAssistancePopup.vue?vue&type=script&lang=js"

import "./LbrxTechnicialAssistancePopup.vue?vue&type=style&index=0&id=73961b84&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73961b84"]])

export default __exports__